import { QUOTE_CANCELLATION } from '../../constants/actions/policy';

export function quoteCancellation(payload) {
    return {
        type: QUOTE_CANCELLATION,
        payload,
    };
}
